<template>
  <el-drawer
    :title="titleDrawer"
    :visible.sync="openDrawerPermission"
    :before-close="closeDrawerPermission"
    @closed="closeDrawerPermission"
    size="45%"
  >
    <el-container direction="vertical" id="permiso-pdf-content">
      <el-main>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form
              ref="form"
              label-position="left"
              size="mini"
              label-width="200px"
              :model="model"
            >
              <el-form-item label="Tipo de Solicitud">
                <!-- <el-switch
                  style="text-align: center; margin-bottom: 2%"
                  v-model="permission"
                  active-text="Permiso"
                  inactive-text="Licencia"
                  :disabled="isView"
                >
                </el-switch> -->

                <el-radio-group
                  v-model="model.Type"
                  :disabled="isView"
                  @change="changeRadio()"
                >
                  <el-radio :label="1">Licencia</el-radio>
                  <el-radio :label="2">Permiso</el-radio>
                  <el-radio v-if="isRRHHOrCEO()" :label="3">Ausencia</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="Fecha Solicitud" v-if="isView == true">
                <el-date-picker
                  type="datetime"
                  format="dd-MM-yyyy HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="Fecha Solicitud"
                  v-model="model.CreatedAt"
                  :disabled="isView"
                >
                </el-date-picker>
              </el-form-item>

              <!-- select employeeId -->
              <el-form-item
                label="Empleado"
                prop="IdEmployee"
                :rules="[
                  {
                    required: true,
                    message: 'Seleccione un empleado',
                    trigger: 'blur'
                  }
                ]"
              >
                <el-select
                  v-loading="autoLoading"
                  v-model="model.IdEmployee"
                  filterable
                  clearable
                  size="mini"
                  placeholder="Colaborador"
                  :disabled="isView"
                  @change="updateSelectedEmployee()"
                >
                  <el-option
                    v-for="item in employeesByDirection"
                    :key="item.EmployeeID"
                    :label="item.Name"
                    :value="item.EmployeeID"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <!-- select LicenseType -->
              <el-form-item
                v-if="model.Type == 1"
                label="Tipo de Licencia"
                prop="LicenseType"
                :rules="[
                  {
                    required: true,
                    message: 'Seleccione un Tipo de Licencia',
                    trigger: 'blur'
                  }
                ]"
              >
                <el-select
                  v-loading="autoLoading"
                  v-model="model.LicenseType"
                  filterable
                  clearable
                  size="mini"
                  placeholder="Tipo de Licencia"
                  :disabled="isView"
                  @change="updateSelectedEmployee()"
                >
                  <el-option
                    v-for="item in LicenseTypes"
                    :key="item.Value"
                    :label="item.Label"
                    :value="item.Value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                v-if="
                  (model.LicenseType == 3 || model.LicenseType == 4) &&
                  !isView &&
                  model.Type == 1
                "
              >
                <el-switch
                  style="text-align: center; margin-bottom: 2%"
                  v-model="AmOrPm"
                  active-text="Matutino"
                  inactive-text="Vespertino "
                >
                </el-switch>
              </el-form-item>

              <el-form-item label="Cedula" v-if="isView == true">
                <el-input
                  type="input"
                  autosize
                  placeholder="Please input"
                  v-model="model.Cedula"
                  :disabled="isView"
                >
                </el-input>
              </el-form-item>

              <el-form-item label="Departamento" v-if="isView == true">
                <el-input
                  type="input"
                  autosize
                  placeholder="Please input"
                  v-model="model.Department"
                  :disabled="isView"
                >
                </el-input>
              </el-form-item>

              <el-form-item label="Posicion" v-if="isView == true">
                <el-input
                  type="input"
                  autosize
                  placeholder="Please input"
                  v-model="model.Position"
                  :disabled="isView"
                >
                </el-input>
              </el-form-item>

              <el-form-item v-if="model.Type == 2 || model.Type == 3">
                <el-switch
                  style="text-align: center; margin-bottom: 2%"
                  v-model="model.permissionDays"
                  active-text="Días"
                  inactive-text="Horas"
                  :disabled="isView"
                >
                </el-switch>
              </el-form-item>

              <el-form-item
                v-if="model.Type == 2 || model.Type == 3"
                label="Duracción"
              >
                <el-select
                  v-loading="autoLoading"
                  v-model="typeDuration"
                  filterable
                  clearable
                  size="mini"
                  placeholder="Duracción"
                  :disabled="isView"
                >
                  <el-option
                    v-for="item in durationType"
                    :key="item.Value"
                    :label="item.Label"
                    :value="item.Value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                label="Desde"
                prop="StartDate"
                :rules="[
                  {
                    required: true,
                    message: 'Inserta una fecha válida',
                    trigger: 'blur'
                  }
                ]"
              >
                <el-date-picker
                  v-model="model.StartDate"
                  type="datetime"
                  format="dd-MM-yyyy HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="Select date and time"
                  :disabled="isView"
                  @change="GetRequestedDaysPermission()"
                >
                </el-date-picker>
              </el-form-item>

              <el-form-item
                label="Hasta"
                prop="FinishDate"
                :rules="[
                  {
                    required: true,
                    message: 'Inserta una fecha válida',
                    trigger: 'blur'
                  }
                ]"
              >
                <el-date-picker
                  v-model="model.FinishDate"
                  type="datetime"
                  format="dd-MM-yyyy HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="Select date and time"
                  :disabled="model.LicenseType != 8 ? true : false"
                >
                </el-date-picker>
                <!-- :disabled="!permission || isView" -->
              </el-form-item>

              <el-form-item
                :label="model.permissionDays ? 'No. Dias' : 'No. Horas'"
              >
                <el-input
                  type="input"
                  autosize
                  placeholder="Please input"
                  v-model="NoDuration"
                  disabled
                >
                </el-input>
              </el-form-item>

              <el-form-item v-if="model.Type == 2">
                <el-switch
                  style="text-align: center; margin-bottom: 2%"
                  v-model="permissionType"
                  active-text="Otros"
                  inactive-text="Salud"
                  :disabled="isView"
                >
                </el-switch>
              </el-form-item>

              <el-form-item
                label="Motivo"
                prop="Reason"
                :rules="[
                  {
                    required: true,
                    message: 'Inserta una razón',
                    trigger: 'blur'
                  }
                ]"
              >
                <el-input
                  type="textarea"
                  autosize
                  placeholder="Please input"
                  v-model="model.Reason"
                  :disabled="isView"
                  style="font-size: 20px"
                >
                </el-input>
              </el-form-item>

              <el-form-item
                label="Comentario de rechazo"
                prop="Rejection_Comment"
                v-if="
                  isView &&
                  (model.SupervisorApproval === 'Rechazado' ||
                    model.RRHH_Approval === 'Rechazado')
                "
              >
                <el-input
                  type="textarea"
                  autosize
                  placeholder="Please input"
                  v-model="model.Rejection_Comment"
                  :disabled="isView"
                  style="font-size: 20px"
                >
                </el-input>
              </el-form-item>

              <el-form-item v-if="!isView" label="Archivo" prop="FileEvidence">
                <UploadFile :refFather="this" ref="UploadFile" />
              </el-form-item>

              <el-form-item
                v-if="this.model.FileEvidence && !isCreated"
                label="Archivo"
              >
                <el-button
                  type="primary"
                  icon="el-icon-document"
                  size="mini"
                  v-on:click="openFile(null)"
                  >Ver Evidencia</el-button
                >
              </el-form-item>

              <el-form-item>
                <el-button
                  v-if="isCreated"
                  type="primary"
                  :loading="autoLoading"
                  @click="validateUpload()"
                  :disabled="autoLoading"
                  >Crear Solicitud</el-button
                >
                <el-button
                  v-if="isView"
                  type="primary"
                  :loading="autoLoading"
                  @click="exportToExcel()"
                  :disabled="autoLoading"
                  >Exportar Excel</el-button
                >
                <el-button
                  v-if="isView"
                  type="primary"
                  :loading="autoLoading"
                  @click="printToPDF()"
                  :disabled="autoLoading"
                  >Imprimir PDF</el-button
                >
                <el-button
                  v-if="isEdit"
                  type="primary"
                  :loading="autoLoading"
                  @click="EditRequestPermission()"
                  :disabled="autoLoading"
                  >Editar Solicitud</el-button
                >
                <el-button
                  @click="closeDrawerPermission()"
                  :disabled="autoLoading"
                  >Cancel</el-button
                >
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </el-drawer>
</template>
<script>
import LicenseType from "@/views/apps/employees/RRHH/Modules/Permission/helpers/LicenseType.js";
import {
  DurationDays,
  DurationHours
} from "@/views/apps/employees/RRHH/Modules/Permission/helpers/Duration.js";
import UploadFile from "@/views/apps/employees/RRHH/Modules/Permission/helpers/UploadFile.vue";
import html2pdf from "html2pdf.js";
import * as XLSX from "xlsx";

export default {
  name: "DrawerPermission",
  DurationDays,
  DurationHours,
  components: {
    UploadFile
  },
  props: {
    openDrawerPermission: {
      type: Boolean,
      default: false
    },

    dataPermissions: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      autoLoading: false,
      data: [],
      titleDrawer: "Solicitud de Permisos",
      permission: true,
      permissionType: true,
      durationType: DurationDays,
      typeDuration: null,
      NoDuration: null,
      LicenseTypes: LicenseType,
      AmOrPm: true,
      //DATA NECESARIA PARA EL FORMULARIO
      conteoDiasSolicitados: 0,
      noDaysWithoutWeeknd: null,
      model: {
        CreatedAt: "",
        IdEmployee: 0, // this.CurrentEmployID,
        LicenseType: "",
        Cedula: "",
        Department: "",
        Position: "",
        NoDays: null,
        NoHours: null,
        permissionDays: true,
        StartDate: "",
        FinishDate: "",
        Period: 0,
        Reason: "",
        SupervisorApproval: 0,
        RRHH_Approval: 0,
        FileEvidence: "",
        Type: 1
      },

      //drawer: false
      isCreated: true,
      isView: false,
      isEdit: false,
      IdUserSelect: 0,

      //the weekend
      countSundays: 0,
      countSaturdays: 0,

      employeesByDirection: [],

      status: {
        Pendiente: { Value: 0 },
        Rechazado: { Value: 1 },
        Aprobado: { Value: 2 },
        Ejecutado: { Value: 3 }
      },

      filesUpload: 0,

      pickerOptions: {
        // Deshabilita las fechas anteriores a la fecha actual
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      }
    };
  },
  mounted() {
    //console.log("Current user id: ", this.currentUser.EmployeeId)
    this.model.IdEmployee = this.currentUser.EmployeeId;
    this.GetEmployees();
    // this.GetRequestedDaysPermission();
  },
  computed: {
    calculateFinishDate() {
      // this.model.StartDate && this.model.LicenseType
      const getDate = new Date(this.model.StartDate);
      let day = 0;

      //esta condición es para licencias
      if (this.model.StartDate && this.model.Type == 1) {
        if (this.model.LicenseType != 8) {
          this.LicenseTypes.forEach((data) => {
            if (data.Value === this.model.LicenseType) {
              this.model.FinishDate = new Date(getDate);
              this.model.StartDate = new Date(getDate);
              if (data.Hours) {
                if (this.AmOrPm) {
                  // si la licencia es "Lactancia (1 Hora)" y es Matutina
                  if (this.model.LicenseType == 3) {
                    this.model.StartDate.setHours(8);
                    this.model.FinishDate.setHours(9);
                  } else if (this.model.LicenseType == 4) {
                    // si la licencia es "Consulta Niño recien nacido (Medio día)" y es Matutina
                    this.model.StartDate.setHours(8);
                    this.model.FinishDate.setHours(12);
                  }
                } else if (!this.AmOrPm) {
                  // si la licencia es "Lactancia (1 Hora)" y es Vespertino
                  if (this.model.LicenseType == 3) {
                    this.model.StartDate.setHours(16);
                    this.model.FinishDate.setHours(17);
                  } else if (this.model.LicenseType == 4) {
                    // si la licencia es "Consulta Niño recien nacido (Medio día)" y es Matutina
                    this.model.StartDate.setHours(12);
                    this.model.FinishDate.setHours(17);
                  }
                } // si es otro tipo de licencia
                else
                  this.model.FinishDate.setHours(
                    getDate.getHours() + data.Hours
                  ); //tomando el valor que dura esa licencia en hora
                day = data.Hours;
              } else {
                this.model.FinishDate.setDate(getDate.getDate() + data.Days); //tomando el valor que dura esa licencia en días
                day = data.Days;
              }
            }
          });
        } else this.calculateNoDays();
      } else if (this.model.StartDate && this.typeDuration) {
        //esta condición es para permisos
        let value = this.model.permissionDays //validando si el permiso es en dias o horas
          ? this.model.NoDays
          : this.model.NoHours;

        this.durationType.forEach((data) => {
          if (data.Value === value) {
            this.model.FinishDate = new Date(getDate);
            this.model.StartDate = new Date(getDate);
            if (!this.model.permissionDays) {
              //si el permiso es solamente de hora (1 <-> 7)
              this.model.FinishDate.setHours(getDate.getHours() + data.Hours);
              day = data.Hours;
            } else {
              if (value == 1) {
                //si el permiso es de una dia, entonces es desde la 8am -> 5pm
                this.model.StartDate.setHours(8);
                this.model.FinishDate.setHours(17);
                return;
              } // si es mayor a 1 un día pues se estable otro día, se poner la hora en 00:00:00
              this.model.StartDate.setHours(0);
              this.model.FinishDate.setHours(0);
              this.model.FinishDate.setDate(getDate.getDate() + data.Days);
              day = data.Days;
            }
          }
        });
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties, no-self-assign
      else this.model.FinishDate = this.model.FinishDate;

      return day;
    }
  },
  watch: {
    calculateFinishDate() {},
    calculateNoHours() {},
    // openDrawerPermission(v) {
    //   // if (v) this.GetRequestedDaysPermission();
    // },
    "model.permissionDays"() {
      this.durationType = this.model.permissionDays
        ? DurationDays
        : DurationHours;
      this.isPermissionDays(this.typeDuration);
    },
    typeDuration(v) {
      this.isPermissionDays(v);
    },
    "model.LicenseType"() {
      this.isLicenseDays();
    },
    "model.Type"() {
      switch (this.model.Type) {
        case 1:
          this.isLicenseDays();
          break;
        case 2:
          this.isPermissionDays(this.typeDuration);
          break;
        default:
          break;
      }
    }
  },
  methods: {
    isRRHHOrCEO() {
      //CEO = 16 // GERENTE RRHH = 68
      if (
        this.currentUser.PositionID == 16 ||
        this.IsInRole(this.roles.GerenteRRHH)
      ) {
        return true;
      }
      return false;
    },
    isPermissionDays(v) {
      //esto es si el permiso es en dia o hora
      if (this.model.permissionDays) {
        //si es en dia afecta a la variable [this.model.NoDays] y coloca la variable [this.model.NoHours] como null
        this.model.NoDays = v;
        this.NoDuration = v;
        this.model.NoHours = null;
        return;
      }
      // esto hace lo contrario
      this.model.NoHours = v;
      this.NoDuration = v;
      this.model.NoDays = null;
    },
    isLicenseDays() {
      //si es en dia afecta a la variable [this.model.NoDays] y coloca la variable [this.model.NoHours] como null
      this.LicenseTypes.forEach(async (data) => {
        if (data.Value === this.model.LicenseType) {
          if (this.model.LicenseType != 8) {
            this.model.NoDays = (await data.Days) ? data.Days : null;
            this.model.permissionDays = (await data.Days) ? true : false;
            this.model.NoHours = (await data.Hours) ? data.Hours : null;
            this.NoDuration = (await data.Hours) ? data.Hours : data.Days;
          } else await this.calculateNoDays();
          return;
        }
      });
    },
    calculateNoDays() {
      if (this.model.StartDate && this.model.FinishDate) {
        const startDate = new Date(this.model.StartDate);
        const finishDate = new Date(this.model.FinishDate);

        // Verificar si la fecha inicial y final son iguales
        const isSameDay =
          startDate.toDateString() === finishDate.toDateString();

        // Calcular la diferencia de horas
        const differenceInHours = (finishDate - startDate) / (1000 * 60 * 60);
        const is8HoursOrMajor = differenceInHours >= 8;

        // Asignar el tipo de permiso (día o hora) a la propiedad "permissionDays"
        this.model.permissionDays = is8HoursOrMajor;

        // Si la fecha inicial y final son iguales y la diferencia de horas es mayor o igual a 8,
        // entonces el resultado es 1 día
        if (isSameDay && is8HoursOrMajor) {
          this.NoDuration = 1;
          this.model.NoDays = 1;
        } else if (isSameDay && !is8HoursOrMajor) {
          //fecha inicial y final son iguales y la diferencia de horas es menor a 8,
          this.NoDuration = differenceInHours; //toma el valor en hora
          this.model.NoHours = differenceInHours; //toma el valor en hora
          return differenceInHours;
        } else;

        const differenceInTime = finishDate.getTime() - startDate.getTime();
        const differenceInDays = Math.ceil(
          differenceInTime / (1000 * 3600 * 24)
        );
        this.NoDuration = differenceInDays; //toma el valor en dia
        this.model.NoDays = differenceInDays; //toma el valor en dia

        return differenceInDays;
      } else {
        this.NoDuration = null;
        this.model.NoDays = null;
        this.model.NoHours = null;
        return "";
      }
    },
    async createPermissionRequestWithFile() {
      await this.$refs.UploadFile.submitUpload(this);
    },
    CreatePermissionRequestWithoutFile() {
      if (this.conteoDiasSolicitados == 2 && this.model.Type == 2) {
        this.$message({
          message: "Alcanzaste el Máximo de permiso en el més.",
          type: "warning"
        });
      } else {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.autoLoading = true;
            this.$http
              .get("/api/Modules/AddPermissionRequest", {
                params: {
                  IdEmployee:
                    this.model.IdEmployee != null
                      ? this.model.IdEmployee
                      : this.currentUser.EmployeeId,
                  NoDays: this.model.NoDays,
                  NoHours: this.model.NoHours,
                  IsDays: this.model.permissionDays ? true : false,
                  StartDate: this.model.StartDate,
                  FinishDate: this.model.FinishDate,
                  LicenseType: this.model.LicenseType,
                  PermissionType:
                    this.permissionType && this.model.Type == 2
                      ? "Otros"
                      : !this.permissionType && this.model.Type == 2
                      ? "Salud"
                      : null,
                  Type:
                    this.model.Type == 1
                      ? "License"
                      : this.model.Type == 2
                      ? "Permission"
                      : "Absence",
                  Reason: this.model.Reason,
                  CreateBy: this.currentUser.EmployeeId,
                  FileEvidence: this.model.FileEvidence
                },
                timeout: 3 * 60 * 100
              })
              .then((resp) => {
                this.data = resp.data;
              })
              .catch((error) => {
                this.$message.error("Error al cargar detalles", error);
              })
              .finally(() => {
                this.autoLoading = false;
                this.closeDrawerPermission();
                this.filesUpload = 0;
              });
          }
        });
      }
    },
    EditRequestPermission() {
      if (this.conteoDiasSolicitados == 2 && this.model.Type == 2) {
        this.$message({
          message: "EL conteo de dias solicitados no puede ser mas de 2.",
          type: "warning"
        });
      } else {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.autoLoading = true;
            this.$http
              .get("/api/Modules/EditPermissionRequest", {
                params: {
                  IdEmployee:
                    this.model.IdEmployee != null
                      ? this.model.IdEmployee
                      : this.currentUser.EmployeeId,
                  NoDays: this.model.NoDays,
                  NoHours: this.model.NoHours,
                  IsDays: this.model.permissionDays ? true : false,
                  StartDate: this.model.StartDate,
                  FinishDate: this.model.FinishDate,
                  Reason: this.model.Reason,
                  LicenseType: this.model.LicenseType,
                  PermissionType:
                    this.permissionType && this.model.Type == 2
                      ? "Otros"
                      : !this.permissionType && this.model.Type == 2
                      ? "Salud"
                      : null,
                  Type:
                    this.model.Type == 1
                      ? "License"
                      : this.model.Type == 2
                      ? "Permission"
                      : "Absence",
                  FileEvidence: this.model.FileEvidence,
                  IdRequest: this.model.IdRequest,
                  SupervisorApproval:
                    this.status[this.model.SupervisorApproval].Value,
                  RRHH_Approval: this.status[this.model.RRHH_Approval].Value
                },
                timeout: 3 * 60 * 100
              })
              .then((resp) => {
                this.data = resp.data;
              })
              .catch((error) => {
                this.$message.error("Error al cargar detalles", error);
              })
              .finally(() => {
                this.autoLoading = false;
                this.closeDrawerPermission();
              });
          }
        });
      }
    },
    GetRequestedDaysPermission() {
      if (this.model.StartDate) {
        const currentDate = new Date(this.model.StartDate);
        const currentMonth = currentDate.getMonth() + 1;
        const currentYear = currentDate.getFullYear();
        this.$http
          .get("/api/Modules/GetRequestedDaysPermission", {
            params: {
              EmployeeID: this.model.IdEmployee,
              Month: currentMonth,
              Year: currentYear,
              type: this.type
            },
            timeout: 3 * 60 * 100
          })
          .then((resp) => {
            this.conteoDiasSolicitados = resp.data;
          })
          .catch((error) => {
            this.$message.error("Error al cargar detalles", error);
          })
          .finally(() => {
            this.autoLoading = false;
          });
      }
    },

    changeRadio() {
      switch (this.model.Type) {
        case 1:
          this.titleDrawer = "Solicitud de Licencia";
          break;
        case 2:
          this.titleDrawer = "Solicitud de Permiso";
          break;
        case 3:
          this.titleDrawer = "Solicitud de Ausencia";
          break;
        default:
          break;
      }
    },

    fileUpload(file) {
      return (this.model.FileEvidence = file);
    },

    async printToPDF() {
      this.autoLoading = true;
      let nameEmployee;
      this.employeesByDirection.forEach(async (d) => {
        if (d.EmployeeID == this.model.IdEmployee) {
          nameEmployee = d.Name;
        }
      });
      const element = await document.getElementById("permiso-pdf-content"); // ID del elemento que deseas imprimir
      await html2pdf()
        .from(element)
        .save(nameEmployee + "-Permiso.pdf");
      this.autoLoading = false;
    },

    async exportToExcel() {
      this.autoLoading = true;
      let nameEmployee;
      this.employeesByDirection.forEach(async (d) => {
        if (d.EmployeeID == this.model.IdEmployee) {
          nameEmployee = d.Name;
        }
      });
      const data = [
        {
          "Fecha de Creación": this.model.CreatedAt,
          Empleado: nameEmployee,
          LicenseType: this.model.LicenseType,
          Cédula: this.model.Cedula,
          Departamento: this.model.Department,
          Posición: this.model.Position,
          "No. Días": this.model.NoDays,
          "No. Horas": this.model.NoHours,
          "Fecha Inicio": this.model.StartDate,
          "Fecha Final": this.model.FinishDate,
          Período: this.model.Period,
          Razon: this.model.Reason,
          "Aprovado Por Supervisor": this.model.SupervisorApproval,
          "Aprovado Por RRHH": this.model.RRHH_Approval,
          Evidenica: this.model.FileEvidence,
          // Tipo: this.model.Type == "Permission" ? "Permiso" : "Licencia"
          Tipo:
            this.model.Type == 1
              ? "Licencia"
              : this.model.Type == 2
              ? "Permiso"
              : "Ausencia"
        }
      ];

      // Crear una nueva hoja de cálculo
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(data);

      // Aplicar estilos y formatos personalizados
      const headerStyle = {
        font: { bold: true },
        alignment: { horizontal: "center" },
        fill: { fgColor: { rgb: "FF000000" } },
        border: { bottom: { style: "thin", color: { rgb: "00000000" } } }
      };

      const cellStyle = {
        alignment: { horizontal: "center" },
        border: { bottom: { style: "thin", color: { rgb: "00000000" } } }
      };

      // Aplicar estilos al encabezado
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let col = range.s.c; col <= range.e.c; col++) {
        const cellAddress = XLSX.utils.encode_cell({ r: range.s.r, c: col });
        if (!worksheet[cellAddress]) continue;
        worksheet[cellAddress].s = headerStyle;
      }

      // Aplicar estilos a las celdas de datos
      for (let row = range.s.r + 1; row <= range.e.r; row++) {
        for (let col = range.s.c; col <= range.e.c; col++) {
          const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
          if (!worksheet[cellAddress]) continue;
          worksheet[cellAddress].s = cellStyle;
        }
      }

      // Ajustar el ancho de las columnas
      const columnWidths = [
        { wch: 10 }, // Ancho de la primera columna
        { wch: 15 } // Ancho de la segunda columna
        // ... y así sucesivamente
      ];
      worksheet["!cols"] = columnWidths;

      // Agregar la hoja de cálculo al libro de trabajo
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // Generar el archivo de Excel
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });

      // Descargar el archivo
      const dataBlob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      const fileName = nameEmployee + "-Permiso.xlsx";
      const downloadLink = document.createElement("a");
      downloadLink.href = URL.createObjectURL(dataBlob);
      downloadLink.download = fileName;
      downloadLink.click();
      this.autoLoading = false;
    },

    closeDrawerPermission() {
      this.$emit("dialog-closed");
      this.clear();
      this.openDrawerPermission = false;
    },

    updateSelectedEmployee() {
      this.GetRequestedDaysPermission();
    },

    getUpdatedData() {
      this.$emit("update-data");
    },

    openFile(url = null) {
      //console.log("url: ", url)
      if (url !== null) {
        window.open(url, "_blank");
      } else {
        window.open(this.model.FileEvidence, "_blank");
      }
    },

    validateUpload() {
      if (this.filesUpload != 0) {
        return this.createPermissionRequestWithFile();
      } else this.CreatePermissionRequestWithoutFile();
    },

    show(data = {}, isView = false, isCreated = false, isEdit = false) {
      if (isCreated) {
        this.isView = false;
        this.titleDrawer = "Solicitud de Permiso";
        this.data = data;
      }
      if (isView) {
        //console.log("data in view: ", data)
        this.isViewData(data, isView, isCreated, isEdit);
      }
      if (isEdit) {
        this.isEditData(data, isView, isCreated, isEdit);
      }
      this.openDrawerPermission = true;
    },

    DelelePermissionRequest(rowData) {
      this.$confirm(
        "Estas seguro que deseas eliminar esta solicitud. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      )
        .then(() => {
          this.$http
            .delete(
              `/api/Modules/DeletePermissionRequest?IdRequest=${rowData.task.IdRequest}`,
              {
                timeout: 3 * 60 * 100
              }
            )
            .then(() => {
              this.$message({
                type: "success",
                message: "Eliminado correctamente"
              });
            })
            .catch((error) => {
              this.$message.error("Error al eliminar la solicitud", error);
            })
            .finally(() => {
              this.autoLoading = false;
              this.closeDrawerPermission();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Eliminación cancelada"
          });
        });
    },
    GetEmployees() {
      let uri;
      if (this.isRRHHOrCEO()) {
        uri = `/api/Employees/GetByCompany?companyID=${this.currentCompany}`;
      } else
        uri = `/api/Employees/GetEmployeeByCriteriaSupervisor?employeeid=${this.currentUser.EmployeeId}`;
      // uri = `/api/Employees/GetEmployeeByCriteriaSupervisor?DepartmentID=${this.deparmentId}&DirectionID=${this.currentUser.DireccionID}&employeeid=${this.currentUser.EmployeeId}`;
      this.$http
        .get(uri)
        .then((resp) => {
          if (this.isRRHHOrCEO()) {
            resp.data.forEach((element) => {
              this.employeesByDirection.push({
                EmployeeID: element.EmployeeID
                  ? element.EmployeeID
                  : element.Id,
                Name: element.FullName ? element.FullName : element.Name
              });
            });
          } else {
            resp.data.user.forEach((element) => {
              this.employeesByDirection.push({
                EmployeeID: element.EmployeeID
                  ? element.EmployeeID
                  : element.Id,
                Name: element.FullName ? element.FullName : element.Name
              });
            });

            resp.data.okEmployee.forEach((element) => {
              this.employeesByDirection.push({
                EmployeeID: element.EmployeeID
                  ? element.EmployeeID
                  : element.Id,
                Name: element.FullName ? element.FullName : element.Name
              });
            });
          }
        })
        .catch((err) => {
          if (err.message.includes("404")) {
            const h = this.$createElement;
            this.$message({
              type: "info",
              //message: "Cliente no encontrado, consultelo en otra empresa"
              message: h("p", null, [
                h("span", null, "Empleado no "),
                h("i", { style: "color: teal" }, "encontrado")
              ])
            });
          } else {
            this.$alert(err.message, err.name, {
              type: "error"
            });
          }
        });
    },

    isViewData(data, isView, isCreated, isEdit) {
      (this.titleDrawer = "Informacion Sobre Solicitud"),
        (this.isCreated = false),
        (this.model = {
          ...this.model,
          ...data.task
        });
      this.permission = this.model.Type == "License" ? false : true;
      this.NoDuration = data.task.IsDays ? data.task.NoDays : data.task.NoHours;
      this.model.permissionDays = data.task.IsDays;
      this.typeDuration = data.task.IsDays
        ? data.task.NoDays
        : data.task.NoHours;
      this.model.Type =
        data.task.Type == "License"
          ? 1
          : data.task.Type == "Permission"
          ? 2
          : 3;
      this.LicenseTypes.forEach((data) => {
        if (this.model.Type == 1 && data.Value == this.model.LicenseType) {
          this.model.LicenseType = data.Label;
        }
      });
      this.isView = isView;
      this.isEdit = isEdit;
      this.data = data.task.row;
    },

    isEditData(data, isView, isCreated, isEdit) {
      (this.titleDrawer = "Editar Informacion Sobre Solicitud"),
        (this.isCreated = false),
        (this.model = {
          ...this.model,
          ...data.task
        });
      this.NoDuration = data.task.IsDays ? data.task.NoDays : data.task.NoHours;
      this.model.permissionDays = data.task.IsDays;
      this.model.Type =
        data.task.Type == "License"
          ? 1
          : data.task.Type == "Permission"
          ? 2
          : 3;
      this.typeDuration = data.task.IsDays
        ? data.task.NoDays
        : data.task.NoHours;
      this.isView = isView;
      this.isEdit = isEdit;
      this.data = data.task.row;
    },

    clear() {
      this.model = {
        CreatedAt: "",
        IdEmployee: this.currentUser.EmployeeId,
        LicenseType: "",
        Cedula: "",
        Department: "",
        Position: "",
        NoDays: null,
        NoHours: null,
        permissionDays: true,
        StartDate: "",
        FinishDate: "",
        Period: 0,
        Reason: "",
        SupervisorApproval: 0,
        RRHH_Approval: 0,
        FileEvidence: "",
        Type: 1
      };
      this.typeDuration = null;
    }
  }
};
</script>
